
import { FolderContentState } from "./types";

interface UseContentStateProps {
  folder: any | null;
  subfolders: any[];
  assessments: any[];
  parentFolder: any | null;
  shareDetails: any | null;
  owner: any | null;
  error: string | null;
  isLoading: boolean;
  isRetrying: boolean;
}

export function useContentState({
  folder,
  subfolders,
  assessments,
  parentFolder,
  shareDetails,
  owner,
  error,
  isLoading,
  isRetrying
}: UseContentStateProps): FolderContentState {
  return {
    folder,
    subfolders,
    assessments,
    parentFolder,
    shareDetails,
    owner,
    error,
    isLoading,
    isRetrying
  };
}
